import React, { Fragment } from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.min.js";
import "../src/helper/style.css";
import { WebRoutes } from "./routes";
import "../src/helper/style.css";

function App() {
  return (
    <Fragment>
      <WebRoutes />
    </Fragment>
  );
}

export default App;
